import { AddressFormFieldNames } from "shared/enums/addressFormFieldNames";
import { NaturalPersonFormFieldNames } from "../enums/naturalPersonFormFieldNames";
import { PersonalInformationFieldNames } from "../enums/personalInformationFieldNames";

// Init referentials dropdown
export const formConfigInitData = {
  [PersonalInformationFieldNames.Civility]:
    'Mr',
  [AddressFormFieldNames.Country]: 'FR',
  [PersonalInformationFieldNames.Nationality]: 'FR',
  [PersonalInformationFieldNames.BirthCountry]: 'FR',
  [PersonalInformationFieldNames.Nationality]:
    'FR',
  [NaturalPersonFormFieldNames.TaxResidenceCountryId]: 'FR'
}
